const lookupTypes = {
  GET_TAGS_SUCCESS: "GET_TAGS_SUCCESS",
  GET_TAGS_LOADING: "GET_TAGS_LOADING",
  GET_TAG_DETAILS_SUCCESS: "GET_TAG_DETAILS_SUCCESS",
  GET_SCROLL_TAGS_SUCCESS: "GET_SCROLL_TAGS_SUCCESS",
};

export default lookupTypes;
